import { ReactNode } from 'react';
import l from '../../../../../lang';
import Filter from '../../../../common/filter';
import Select from '../../../../common/select';
import { Filters } from '../../../../../store/interfaces';
import { useAvailableCountries } from '../../../../../hooks/use-available-countries';
import './styles.scss';

interface ClientsFilterGroupedProps {
  appliedFilters: Filters;
  clearFilters: () => void;
  changeFilters: (filters: Filters) => void;
  exportButton?: ReactNode;
}

const ClientsFilterGrouped = ({
  appliedFilters,
  clearFilters,
  changeFilters,
  exportButton,
}: ClientsFilterGroupedProps) => {
  const allCountries = useAvailableCountries();

  const sortDirectionOptions = {
    desc: l('clients.filter.sortDirection.desc'),
    asc: l('clients.filter.sortDirection.asc'),
  };

  const sortByOptions = {
    client_id: l('clients.filter.sortBy.merchantClientId'),
    transacted_amount: l('clients.transactedAmount'),
    first_name: l('clients.filter.sortBy.firstName'),
    last_name: l('clients.filter.sortBy.lastName'),
    email: l('clients.filter.sortBy.email'),
    created_date: l('clients.filter.sortBy.createdAt'),
  };

  const statusOptions = {
    ACTIVE: l('clients.status.ACTIVE'),
    INACTIVE: l('clients.status.INACTIVE'),
    NEW: l('clients.status.NEW'),
  };

  const countryOptions = allCountries.reduce<Record<string, string>>((acc, countryCode) => {
    acc[countryCode] = l(`countryCode.${countryCode}`);
    return acc;
  }, {});

  const activeFilters = Object.values(appliedFilters).filter(value => value)?.length || null;

  return (
    <div className="clients_filter_grouped">
      <Filter
        clearFilter={clearFilters}
        appliedFilters={activeFilters}
        items={[
          {
            title: <span className="clients_filter_grouped__title">{l('clients.filter.sortDirection')}</span>,
            component: (
              <Select
                name="sort_direction"
                defaultOptionText={l('clients.filter.sortDirection')}
                defaultOptionEnabled
                value={appliedFilters.sort_direction}
                size="lg"
                options={sortDirectionOptions}
                onChange={e => {
                  changeFilters({ ...appliedFilters, sort_direction: e.target.value });
                }}
              />
            ),
          },
          {
            title: <span className="clients_filter_grouped__title">{l('clients.filter.sortBy')}</span>,
            component: (
              <Select
                name="sort_by"
                defaultOptionText={l('clients.filter.sortBy')}
                defaultOptionEnabled
                value={appliedFilters.sort_by}
                size="lg"
                options={sortByOptions}
                onChange={e => {
                  changeFilters({ ...appliedFilters, sort_by: e.target.value });
                }}
              />
            ),
          },
          {
            title: <span className="clients_filter_grouped__title">{l('clients.filter.country')}</span>,
            component: (
              <Select
                name="country"
                defaultOptionText={l('clients.filter.country')}
                defaultOptionEnabled
                value={appliedFilters.country}
                size="lg"
                options={countryOptions}
                onChange={e => {
                  changeFilters({ ...appliedFilters, country: e.target.value });
                }}
              />
            ),
          },
          {
            title: <span className="clients_filter_grouped__title">{l('clients.filter.status')}</span>,
            component: (
              <Select
                name="status"
                defaultOptionText={l('clients.filter.status')}
                defaultOptionEnabled
                value={appliedFilters.status}
                size="lg"
                options={statusOptions}
                onChange={e => {
                  changeFilters({ ...appliedFilters, status: e.target.value });
                }}
              />
            ),
          },
        ]}
      />
      {exportButton && <div className="clients_filter_grouped__export">{exportButton}</div>}
    </div>
  );
};

export default ClientsFilterGrouped;
